export const SHORT_MASK = "+99 (99) 9999-9999";
export const LONG_MASK = "+99 (99) 99999-9999";
